// import Vue from 'vue';
import router from './scripts/router.js';
import env from '@/env.js';
import { createApp } from 'vue';
import App from './App.vue';
import * as Sentry from "@sentry/vue";

const app = createApp(App);

if (!env.dev) {
    Sentry.init({
        app,
        dsn: "https://974038e7c68a4331bb641175565f2832@o1047336.ingest.sentry.io/6485297",
        integrations: [
            Sentry.browserTracingIntegration({
                router,
            }),
            Sentry.replayIntegration(),
        ],

        denyUrls: [/extensions\//i, /^chrome-extension:\/\//i, /^moz-extension:\/\//i, /^safari-(web-)?extension:\/\//i],

        ignoreErrors: [
            /Krisp error fetching/i,
            /Failed to fetch/i,
            /Error when starting local audio level observer/i,
            /toCameraError is not a function/i,
            /Meeting has ended/i,
            /bad sigauthz token/i,
            /Request aborted/i,
            /Timed out \(>20000 ms\) when loading call object bundle/i,
            /camera_\w+: \(unknown error\)/i,
            /Network Error: https:\/\/c\.daily\.co\//i
        ],

        beforeSend(event) {
            return isVendorStackOverflow(event) ? null : event;
        },

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

// Stack overflows entirely inside third-party code (e.g. Daily's deep-equality check recursing
// into DOM nodes on some machines) aren't actionable. Keep any that involve our own code.
function isVendorStackOverflow(event) {
    const exception = event.exception?.values?.[0];
    const frames = exception?.stacktrace?.frames;

    return exception?.type === 'RangeError' &&
        frames?.length > 0 &&
        frames.every(frame => /chunk-vendors/.test(frame.filename || ''));
}

app.use(router);
app.mount("#app");
